import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
const Footer = () => {
  return <footer id="contacto" className="bg-[#146ead] text-white py-12" data-id="element-43">
      <div className="container mx-auto px-4" data-id="element-44">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-45">
          <div data-id="element-46">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hYfcvFkA5ig3Y9Rk5E8PSp/LOGO_LANDING.png" alt="Guaterflow Logo" className="h-16 mb-4 bg-white p-2 rounded" data-id="element-47" />
            <p className="text-sm" data-id="element-48">
              Consolidando el primer sistema descentralizado, digital y
              solidario de agua potable en Guatemala.
            </p>
            <div className="flex space-x-4 mt-4" data-id="element-49">
              <a href="#" className="hover:text-blue-200 transition-colors" data-id="element-50">
                <FacebookIcon size={20} data-id="element-51" />
              </a>
              <a href="#" className="hover:text-blue-200 transition-colors" data-id="element-52">
                <InstagramIcon size={20} data-id="element-53" />
              </a>
              <a href="#" className="hover:text-blue-200 transition-colors" data-id="element-54">
                <TwitterIcon size={20} data-id="element-55" />
              </a>
            </div>
          </div>
          <div data-id="element-56">
            <h3 className="text-lg font-semibold mb-4" data-id="element-57">Enlaces rápidos</h3>
            <ul className="space-y-2" data-id="element-58">
              <li data-id="element-59">
                <a href="#inicio" className="hover:text-blue-200 transition-colors" data-id="element-60">
                  Inicio
                </a>
              </li>
              <li data-id="element-61">
                <a href="#planes" className="hover:text-blue-200 transition-colors" data-id="element-62">
                  Planes
                </a>
              </li>
              <li data-id="element-63">
                <a href="#como-funciona" className="hover:text-blue-200 transition-colors" data-id="element-64">
                  Cómo Funciona
                </a>
              </li>
              <li data-id="element-65">
                <a href="#impacto-social" className="hover:text-blue-200 transition-colors" data-id="element-66">
                  Impacto Social
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-67">
            <h3 className="text-lg font-semibold mb-4" data-id="element-68">Contacto</h3>
            <ul className="space-y-2" data-id="element-69">
              <li className="flex items-center" data-id="element-70">
                <PhoneIcon size={16} className="mr-2" data-id="element-71" />
                <span data-id="element-72">+502 4693-3600</span>
              </li>
              <li className="flex items-center" data-id="element-73">
                <MailIcon size={16} className="mr-2" data-id="element-74" />
                <span data-id="element-75">info@guaterflow.com</span>
              </li>
              <li className="flex items-start" data-id="element-76">
                <MapPinIcon size={16} className="mr-2 mt-1" data-id="element-77" />
                <span data-id="element-78">Zacapa, Zacapa, Guatemala</span>
              </li>
            </ul>
          </div>
          <div data-id="element-79">
            <h3 className="text-lg font-semibold mb-4" data-id="element-80">
              Suscríbete al newsletter
            </h3>
            <p className="text-sm mb-4" data-id="element-81">
              Recibe noticias y promociones especiales.
            </p>
            <form data-id="element-82">
              <div className="flex" data-id="element-83">
                <input type="email" placeholder="Tu email" className="px-3 py-2 rounded-l-lg text-gray-800 w-full focus:outline-none" data-id="element-84" />
                <button type="submit" className="bg-[#2d98e2] hover:bg-blue-700 px-4 py-2 rounded-r-lg transition-colors" data-id="element-85">
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="border-t border-blue-400 mt-10 pt-6 text-center text-sm" data-id="element-86">
          <p data-id="element-87">
            &copy; {new Date().getFullYear()} Guaterflow. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;